<wdx-icon
    class="align-content-center justify-content-center"
    [scale]="1.5"
    icon="refresh"
    (click)="refreshClick()"
></wdx-icon>
